import hero from '../../media/hero.png';
export default function Hero() {
    return <img src={hero} className="img-fluid w-100" alt="Homemoto" />;
}